import { render, staticRenderFns } from "./Editar-Comunicado.vue?vue&type=template&id=3f8e82fc&"
import script from "./Editar-Comunicado.vue?vue&type=script&lang=js&"
export * from "./Editar-Comunicado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Editar-Comunicado.vue"
export default component.exports